module.exports = __webpack_public_path__ + "media/images/landkit/buttons/button-app-891ce87a5d15d870a28b6c20bf8d8bb9.png";